import { normalize, publicationYear, publicationLanguage, authorList } from '../publications/publicationTypes';

// A talk is an oral presentation unless its tags say otherwise.
export const talkFormats = [
  ['talk', 'Apresentação oral', 'Oral presentation'],
  ['round table', 'Mesa redonda', 'Round table'],
];
export const talkFormat = talk => (Array.isArray(talk.tags) ? talk.tags : [])
  .some(tag => /mesa redonda|round table/i.test(String(tag))) ? 'round table' : 'talk';

// The event is where the talk was given; the host is who convened it.
export const talkEvent = talk => talk['event-title'] || talk['container-title'] || '';
export const talkHost = talk => talk.publisher || '';
export const talkPlace = talk => talk['publisher-place'] || '';

// The modal offers a recording tab for exactly this field, so the listing flags the same talks.
export const hasRecording = talk => !!talk.youtubeLink;

export function filterTalks(talks, { query = '', language = '', host = '', format = '', year = '' }) {
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  return talks.filter(talk => (!language || publicationLanguage(talk) === language)
    && (!host || talkHost(talk) === host)
    && (!format || talkFormat(talk) === format)
    && (!year || publicationYear(talk) === year)
    && words.every(word => normalize([
      talk.title, talk.titleEn, talk.abstract, talk.abstractEn, talk.keyword, talk.keywordsEn,
      talk.id, talkEvent(talk), talkHost(talk), talkPlace(talk),
      publicationYear(talk), authorList(talk.author),
    ].join(' ')).includes(word)));
}
